<!--
// See https://community-dc.max.gov/x/h4Gzmw for overview of how this field type is implemented
-->

<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-template #tooltipTemplate><ng-content select="[projectedTooltip]"></ng-content></ng-template>

@if (DisplayAsInput) {

  <div class="height-100-percent">
    @if (this.Mode === 'design') {
      <div class="flex-row-top-right">
        <div class="fill-remaining-space">
          <!-- If there are instructions, display label first, then instructions then field -->
          @if (this.HasInstructions) {
            @if (this.DisplayName) {
              <div class="design-mode-field-label">{{this.DisplayName}} @if (this.FormField.required) {
                <span style="color: #EF0000;">*</span>
              }</div>
            }
            <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
          }
          <mat-form-field appearance="outline"
            [floatLabel]="'always'">
            @if (this.ShowLabel && !HasInstructions) {
              <mat-label
                class="design-mode-field-label">{{this.DisplayName}} @if (this.FormField.required) {
                <span style="color: #EF0000;">*</span>
              }</mat-label>
            }
            <input matInput
              placeholder="{{this.PlaceholderText}}"
              value="{{FormField.formula}}"
              disabled />
            </mat-form-field>
            @if (FormField.isUsedToSetFormInstanceConcatenatedId) {
              <div class="field-label">Important: The value of this field is configured to be saved to FormInstance.ConcatenatedId when a Form instance is saved. Only one field should be configured this way.</div>
            }
            <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
          </div>
          <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
        </div>
      }
      @if ((this.Mode === 'preview') || (this.Mode === 'instance')) {
        <div class="flex-row-top-right height-100-percent">
          <div class="fill-remaining-space height-100-percent">
            @if ((this.ControlType === 'Reactive Forms') && this.FormControl !== null) {
              <!-- If there are instructions, display label first, then instructions then field ...-->
              @if (this.HasInstructions) {
                @if (this.DisplayName) {
                  <div class="field-label">
                    {{this.DisplayName}}
                    <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
                  </div>
                }
              }
              <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
                <!-- If there are no instructions, display label integrated into the field -->
                @if (this.ShowLabel && !this.HasInstructions && !FieldIsInGrid) {
                  <mat-label class="field-label">{{this.DisplayName}} </mat-label>
                }
                @if (!this.UseGridSpecificStyling) {
                  <!--outside grid-->
                  <input matInput
                    type="text"
                    id="{{this.MatInputId}}"
                    [readonly]="true"
                    class="null-tooltip-mat-input"
                    placeholder="{{this.PlaceholderText}}"
                    [formControl]="this.FormControl"
                    (blur)="this.handleOnBlur()"
                    (focus)="this.handleOnFocus($event)" />
                  }
                  @if (this.UseGridSpecificStyling) {
                    <!--inside grid-->
                    <textarea #gridOnlyTextArea
                      matInput
                      [readonly]="this.ReadOnly"
                      class="height-100-percent"
                      placeholder="{{this.PlaceholderText}}"
                      [formControl]="this.FormControl"
                      (blur)="this.handleOnBlur()"
                      (focus)="this.handleOnFocus($event)"
                      rows="{{this.NumGridOnlyTextAreaRows}}">
                    </textarea>
                  }
                </mat-form-field>
                <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
              }
            </div>
            <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
          </div>
        }
      </div>

    } @else {

      @if (this.Mode=='design') {
        <span>
          <button kendoButton [disabled]="true">{{ButtonLabel}}</button> <span style="color:darkgrey">&nbsp;({{FormField.formula}})</span>
        </span>
      }
      @if (this.Mode=='preview' || this.Mode=='instance') {
        <span>
          <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
          <button kendoButton (click)="openUrl()" title="Go to {{this.FormControl?.value}}">{{ButtonLabel}}</button>
        </span>
      }

    }
